// src/js/reducers/index.js
import * as types from "../constants/action-types";

export default function menuReducer(state = [], action) {
    switch (action.type) {
       
        case types.LOGOUT:
            return []
        case types.LOAD_MENU_SUCCESS:         
            return action.menu;      
        default:
            return state;
    };
};


